import { Base } from 'app/components/ui/Base'
import { useLayout } from 'app/contexts/LayoutProvider'
import { protectedRoutes } from 'app/routing/routes'
import { SponsorRequest } from 'EstraSponsor'
import React, { useLayoutEffect, useReducer } from 'react'
import { useHistory } from 'react-router-dom'

import { SponsorRequestDataForm } from './SponsorRequestDataForm'
import { SponsorRequestFilesForm } from './SponsorRequestFilesForm'
import { SponsorRequestThanks } from './SponsorRequestThanks'

type FormSteps = 'data_step' | 'files_step' | 'success_step'

type FormStepsReducerState = {
  step: FormSteps
  sponsorRequest?: SponsorRequest
}

type FormStepsReducerAction =
  | { type: 'data_step'; sponsorRequest: SponsorRequest }
  | { type: 'files_step'; sponsorRequest: SponsorRequest }
  | { type: 'success_step' }

const reducer = (
  state: FormStepsReducerState,
  action: FormStepsReducerAction
): FormStepsReducerState => {
  switch (action.type) {
    case 'data_step':
      return {
        ...state,
        step: action.type,
        sponsorRequest: action.sponsorRequest,
      }
    case 'files_step':
      return {
        ...state,
        step: action.type,
        sponsorRequest: action.sponsorRequest,
      }
    case 'success_step':
      return { ...state, step: action.type, sponsorRequest: undefined }
  }
}

type Props = {
  isEdit: boolean
  sponsorRequest?: SponsorRequest
}

export const SponsorRequestForm = ({
  isEdit,
  sponsorRequest,
}: Props): JSX.Element => {
  const { push } = useHistory()
  const { updateLayoutData } = useLayout()

  const [{ step, sponsorRequest: currentSponsorRequest }, dispatch] =
    useReducer(reducer, {
      step: 'data_step',
      sponsorRequest: sponsorRequest,
    })

  useLayoutEffect(() => {
    updateLayoutData({
      title:
        step === 'success_step'
          ? 'Richiesta completata ma non inviata'
          : isEdit
          ? `Modifica la richiesta ${sponsorRequest?.name || ''}`
          : 'Nuova richiesta',
      subTitle: undefined,
      headerVariant: 'sponsor_request_form',
    })
  }, [updateLayoutData, isEdit, sponsorRequest, step])

  return (
    <Base>
      {step === 'data_step' ? (
        <>
          <SponsorRequestDataForm
            sponsorRequest={currentSponsorRequest}
            onNextStep={(updatedSponsorRequest) => {
              dispatch({
                type: 'files_step',
                sponsorRequest: updatedSponsorRequest,
              })
            }}
          ></SponsorRequestDataForm>
        </>
      ) : step === 'files_step' && currentSponsorRequest ? (
        <SponsorRequestFilesForm
          sponsorRequest={currentSponsorRequest}
          onPreviousStep={(currentSponsorRequest) => {
            dispatch({
              type: 'data_step',
              sponsorRequest: currentSponsorRequest,
            })
          }}
          onNextStep={() => dispatch({ type: 'success_step' })}
        ></SponsorRequestFilesForm>
      ) : (
        <SponsorRequestThanks
          onNextStep={() => push(protectedRoutes.dashboard.path)}
        />
      )}
    </Base>
  )
}
